import React from 'react';

const TaxonomyLoadingState: React.FC = () => {
  return (
    <div className="flex min-h-[32rem] w-full items-center justify-center rounded-lg border border-border bg-card shadow-[var(--shadow-card)]">
      <div className="text-center">
        <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-accent">
          <div className="h-8 w-8 animate-spin rounded-full border-b-2 border-primary" />
        </div>
        <h3 className="mb-2 text-lg font-semibold text-foreground">Loading taxonomy</h3>
        <p className="text-[13px] leading-[1.7] text-muted-foreground">
          Preparing your classification visualization.
        </p>
      </div>
    </div>
  );
};

export default TaxonomyLoadingState;
